import React, { memo } from 'react'
import { Input, Select } from '@guillotinaweb/react-gmi'
import ProductSelectorOrQuery from '../../../components/product-selector-or-query'
import { I18NField } from '../../../components/i18nfield'
import { catalogs } from '../../../consts'
import { frontThemes } from '../../../consts'

const Empty = () => null

export const CatalogForm = memo(({ selected, edit, langs }) => {
  const hasButton =
    selected.id === 'special' || !(selected.type || '').startsWith('Carousel')

  return (
    <I18NField key={langs.join()} langs={langs} Widget={Empty}>
      {(lang) => (
        <>
          <label className="label">Title</label>
          <Input
            value={selected.title ? selected.title[lang] : ''}
            onChange={(v) => edit('title', { ...selected.title, [lang]: v })}
          />
          {selected.id === 'special' && (
            <>
              <label className="label">Subtitle</label>
              <Input
                value={selected.subtitle ? selected.subtitle[lang] : ''}
                onChange={(v) =>
                  edit('subtitle', { ...selected.subtitle, [lang]: v })
                }
              />
            </>
          )}

          {hasButton && (
            <>
              <label className="label">Button text</label>
              <Input
                value={selected.buttonText ? selected.buttonText[lang] : ''}
                onChange={(v) =>
                  edit('buttonText', { ...selected.buttonText, [lang]: v })
                }
              />
            </>
          )}
          {selected.id === 'special' && (
            <>
              <label className="label">Button link</label>
              <Input
                key={`buttobnlink-${lang}`}
                value={selected.buttonLink ? selected.buttonLink[lang] : ''}
                onChange={(v) =>
                  edit('buttonLink', { ...selected.buttonLink, [lang]: v })
                }
              />
            </>
          )}
          <label className="label">Catalog type</label>
          <Select
            options={catalogs.map((k) => ({
              label: k,
              value: k,
            }))}
            value={selected.type}
            onChange={(e) => edit('type', e.target.value)}
          />
          <label className="label mt10">Theme</label>
          <Select
            options={frontThemes.map((k) => ({ label: k, value: k }))}
            value={selected.theme}
            onChange={(e) => edit('theme', e.target.value)}
          />
          {selected.id === 'special' && (
            <ProductSelectorOrQuery
              id={selected.id}
              query={selected.query}
              setQuery={(query) => edit('query', query)}
            />
          )}
        </>
      )}
    </I18NField>
  )
})
